'use strict';

import $ from 'jquery';

import headerCart from './header-cart';
import initOneClick from './oneclick';
import initCheckoutCart from './cart';
import initCheckoutShipping from './shipping';
import initCheckoutPayment from './payment';
import initCheckoutLogin from './login';
import applePay from './applepay';

export default function(API) {
	API.applePay = applePay;

	$(document).ready(() => {

		headerCart.init();

		initOneClick();
		initCheckoutCart();
		initCheckoutShipping();
		initCheckoutPayment();
		initCheckoutLogin();
	});
}
